import {AfterViewInit, Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {GridsterConfig} from "angular-gridster2";
import {DashboardWidget} from "../../../../shared/store/report/report-dashboard";
import {AppState} from "../../../../shared/store/store";
import {Store} from "@ngrx/store";
import {reportDashboardUpdateWidgets} from "../../../../shared/store/report/report.actions";
import * as lodash from 'lodash';
import {showOpacityAnimation} from "../../../../shared/animations/show-opacity.animation";

@Component({
  selector: 'app-move-widgets-dialog',
  templateUrl: './move-widgets-dialog.component.html',
  styleUrls: ['./move-widgets-dialog.component.scss'],
  animations: [showOpacityAnimation]
})
export class MoveWidgetsDialogComponent implements OnInit, AfterViewInit {
  public dashboard: DashboardWidget[];
  public readonly options: GridsterConfig = {
    gridType: 'verticalFixed',
    margin: 20,
    padding: 20,
    maxCols: 6,
    minCols: 6,
    minRows: 40,
    fixedRowHeight: 10,
    maxRows: 2000,
    draggable: {
      enabled: true
    },
    resizable: {
      enabled: true
    },
    swap: true,
    pushItems: true
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: { dashboard: DashboardWidget[] },
    public readonly dialogRef: MatDialogRef<MoveWidgetsDialogComponent>,
    private readonly _store: Store<AppState>
  ) {}

  public ngOnInit(): void {
    this.dashboard = lodash.cloneDeep(this.data.dashboard);
  }

  public ngAfterViewInit(): void {}

  public onSubmit(): void {
    this._store.dispatch(reportDashboardUpdateWidgets({
      dashboard: this.dashboard
    }));

    this.dialogRef.close();
  }

}
